import { render, staticRenderFns } from "./EditImageForm.vue?vue&type=template&id=63ac79d8&scoped=true&"
import script from "./EditImageForm.vue?vue&type=script&lang=ts&"
export * from "./EditImageForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditImageForm.vue?vue&type=style&index=0&id=63ac79d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ac79d8",
  null
  
)

export default component.exports